import { ComisionesPagoServicios } from "../../domain/models/ComisionesPagoServicios";

export const comsPagoDataToCsv = (data: ComisionesPagoServicios[]) => {

  let csv: Array<Array<any>> = [];
  csv.push(['Fecha', 'hora', 'Tipo Modelo', 'Carrier', 'Destino', 'Medio', 'Monto', 'Num Op Prepago', 'Mov Clave', 'Saldo Inicial', 'Comisión Compra', 'Cobro Por Servicio', 'Ajuste Por Comisión Compra', 'Saldo Final']);


  data.forEach((item: ComisionesPagoServicios) => {
    csv.push([
      item.fecha,
      item.hora,
      item.tipo_modelo,
      item.carrier,
      item.destino,
      item.medio,
      item.monto,
      item.num_op_prepago,
      item.mov_clave,
      item.saldo_ini_pdv,
      item.comision_compra_pdv,
      item.comision_servicio_pdv,
      item.ajuste_compra_pdv,
      item.saldo_fin_pdv
    ]);
  });
  return csv;
}
